"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Protocols = void 0;
var Protocols;
(function (Protocols) {
    Protocols["xrpl"] = "XRPL";
    Protocols["evm"] = "EVM";
    Protocols["btc"] = "BTC";
    Protocols["bsc"] = "BSC";
    Protocols["ada"] = "ADA";
    Protocols["sol"] = "SOL";
    Protocols["usd"] = "USD";
})(Protocols || (exports.Protocols = Protocols = {}));
//# sourceMappingURL=index.js.map